import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-807aac90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "upload-hint" }, " 支持 pdf / doc / docx，不超过 20MB ", -1))

import { computed, ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseSwitch,
  BaseUpload,
  BaseFormRef,
  BaseButton,
  XrkMessageBox,
  XrkMessage
} from 'xrk-components';

import { uploadApi } from '@/common/data-source/common/apis';
import { saveTerminalTemplate, getTerminalTemplate } from '../data-source/apis';
import type { TerminalTemplateRow } from '../data-source/types';
import { TerminalTemplateStatus } from '../constants';
import { BaseDatepickerLongterm } from '@/components/base/base-datepicker-longterm/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-template-dialog',
  props: {
    remove: { type: Function },
    id: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const isEdit = computed(() => props.id != null);

const formRef = ref<BaseFormRef>(null);
const saving = ref(false);

const formData = ref({
  contractTemplateName: '',
  contractTemplateUrl: [],
  urlFileName: '',
  validity: [],
  enabled: TerminalTemplateStatus.ENABLED,
  remarks: ''
});

const rules = {
  contractTemplateName: [
    { required: true, message: '请输入模版名称', trigger: 'blur' }
  ],
  contractTemplateUrl: [
    {
      required: true,
      validator: (_, __, cb) => {
        if (!isEdit.value && !formData.value.contractTemplateUrl.length) {
          return cb(new Error('请上传模版文件'));
        }
        cb();
      },
      trigger: 'change'
    }
  ],
  validity: [
    {
      required: true,
      validator: (_rule: any, value: any, callback: any) => {
        if (!value?.length) {
          callback(new Error('合同有效期不能为空'));
        } else {
          callback();
        }
      },
      trigger: 'change'
    }
  ]
};

const handleValidityChange = () => {
  formRef.value.validateField('validity');
};

const onUploadError = (info: { msg: string }) => {
  XrkMessage.error(info.msg);
};

const loadDetail = async () => {
  if (!isEdit.value || !props.id) return;
  const { data } = await getTerminalTemplate({ id: props.id });
  formData.value = {
    contractTemplateName: data.contractTemplateName,
    contractTemplateUrl: [
      { url: data.contractTemplateUrl, name: data.urlFileName }
    ],
    urlFileName: data.urlFileName,
    validity: data.validityStart ? [data.validityStart, data.validityEnd] : [],
    enabled: data.enabled,
    remarks: data.remarks || ''
  };
};

onMounted(loadDetail);

const onCancel = () => props.remove();

const onSubmit = async (check: number) => {
  await formRef.value?.validate();

  saving.value = true;
  try {
    const contractTemplateUrl = formData.value.contractTemplateUrl[0]?.url;
    const urlFileName = formData.value.contractTemplateUrl[0]?.name;

    const payload: Omit<TerminalTemplateRow, 'id' | 'createAt'> & {
      id?: number;
    } = {
      ...(isEdit.value ? { id: props.id } : {}),
      contractTemplateName: formData.value.contractTemplateName,
      contractTemplateUrl,
      urlFileName,
      validityStart: formData.value.validity?.[0] || null,
      validityEnd: formData.value.validity?.[1] || null,
      enabled: formData.value.enabled,
      remarks: formData.value.remarks,
      type: 5
    };
    saveTerminalTemplate({ ...payload, check }).then(async ({ data }) => {
      if (+data === 7778) {
        XrkMessageBox.confirm(
          '已存在该模版，是否继续添加，如添加则原合同将会失效',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }
        ).then(async () => {
          onSubmit(0);
        });
      } else {
        emits('success');
        props.remove();
      }
    });
  } finally {
    saving.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    "custom-class": "terminal-template-dialog",
    title: isEdit.value ? '编辑模版' : '新建模版',
    width: "560px",
    "model-value": true,
    onClose: onCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        loading: saving.value,
        click: () => onSubmit(1)
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      }, 8, ["loading", "click"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          model: formData.value,
          rules: rules,
          "label-width": "120px",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "模版名称",
              prop: "contractTemplateName"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  modelValue: formData.value.contractTemplateName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.contractTemplateName) = $event)),
                  maxlength: "50",
                  "show-word-limit": "",
                  placeholder: "请输入模版名称（最多 50 字）"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "模版文件",
              prop: "contractTemplateUrl"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseUpload), {
                  ref: "uploadRef",
                  fileList: formData.value.contractTemplateUrl,
                  "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.contractTemplateUrl) = $event)),
                  autoUpload: true,
                  "http-request": _unref(uploadApi),
                  accept: ['.pdf', '.doc', '.docx'],
                  limit: 1,
                  limitSize: 20,
                  onError: onUploadError
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseButton), { type: "primary2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("点击上传")
                      ]),
                      _: 1
                    }),
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["fileList", "http-request"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "合同有效期",
              prop: "validity"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseDatepickerLongterm), {
                  style: {"width":"100%","margin-top":"1px"},
                  startPlaceholder: "有效期始",
                  endPlaceholder: "有效期止",
                  value: formData.value.validity,
                  "onUpdate:value": [
                    _cache[2] || (_cache[2] = ($event: any) => ((formData.value.validity) = $event)),
                    handleValidityChange
                  ]
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "状态",
              prop: "enabled"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseSwitch), {
                  modelValue: formData.value.enabled,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.enabled) = $event)),
                  "active-value": _unref(TerminalTemplateStatus).ENABLED,
                  "inactive-value": _unref(TerminalTemplateStatus).DISABLED,
                  "active-text": "启用",
                  "inactive-text": "停用"
                }, null, 8, ["modelValue", "active-value", "inactive-value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "备注",
              prop: "remarks"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"300px"},
                  modelValue: formData.value.remarks,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.remarks) = $event)),
                  type: "textarea",
                  rows: 3,
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "请输入备注（≤200 字）"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})